import { render } from "./TecnologiesBox.vue?vue&type=template&id=5520301a&scoped=true"
import script from "./TecnologiesBox.vue?vue&type=script&lang=js"
export * from "./TecnologiesBox.vue?vue&type=script&lang=js"

import "./TecnologiesBox.vue?vue&type=style&index=0&id=5520301a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5520301a"]])

export default __exports__